import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';

// Education Box Styling with Background Image
const EducationBox = styled(Box)(({ theme, bgImage }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3),
  backgroundImage: `url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '8px',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  height: '300px', // Set a fixed height for the box
  textAlign: 'center',
  color: '#fff', // Text color for better contrast
  position: 'relative',
  '&:hover': {
    transform: 'scale(1.05)',
  },
}));

const Education = () => {
  return (
    <Box sx={{ py: 6, px: 2 }}>
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          textAlign: 'center',
          mb: 4,
          fontWeight: 'bold',
          color: '#333',
        }}
      >
        Education
      </Typography>

      {/* Education Grid */}
      <Grid container spacing={3} justifyContent="center">
        {/* College Section */}
        <Grid item xs={12} sm={6} md={4}>
          <EducationBox bgImage={`${process.env.PUBLIC_URL}/College.jpg`}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
              Government College of Engineering, Tirunelveli
            </Typography>
            <Typography variant="body1" sx={{ color: '#fff' }}>
              7.87 CGPA
            </Typography>
          </EducationBox>
        </Grid>

        {/* 12th Section */}
        <Grid item xs={12} sm={6} md={4}>
          <EducationBox bgImage={`${process.env.PUBLIC_URL}/school.jpg`}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
              Chellammal Matriculation Higher Secondary School
            </Typography>
            <Typography variant="body1" sx={{ color: '#fff' }}>
              95% - 12th (2021)
            </Typography>
          </EducationBox>
        </Grid>

        {/* 10th Section */}
        <Grid item xs={12} sm={6} md={4}>
          <EducationBox bgImage={`${process.env.PUBLIC_URL}/school.jpg`}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
              Chellammal Matriculation Higher Secondary School
            </Typography>
            <Typography variant="body1" sx={{ color: '#fff' }}>
              94.8% - 10th (2019)
            </Typography>
          </EducationBox>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Education;
